import { Injectable } from "@angular/core";
import { DetachedRouteHandle } from "@angular/router";

@Injectable()
export class DetachedRouteHandleService {
  private readonly map: Map<string, DetachedRouteHandle> = new Map();
  private readonly releasedMap: Map<string, boolean> = new Map();

  constructor() {
    (<any>window)["detachedRouteHandleService"] = {
      map: this.map,
      releasedMap: this.releasedMap
    };
  }

  store(key: string, handle: DetachedRouteHandle): void {
    this.map.set(key, handle);
  }

  get(key: string): DetachedRouteHandle | undefined {
    return this.map.get(key);
  }

  has(key: string): boolean {
    return this.map.has(key);
  }

  isReleased(key: string): boolean {
    return this.releasedMap.has(key);
  }

  delete(key: string): void {
    this.map.delete(key);
  }

  deleteReleeased(key: string): void {
    this.releasedMap.delete(key);
  }

  setReleased(key: string): void {
    this.releasedMap.set(key, true);
  }
}
